import {Group, Text} from '@mantine/core';
import {Logo} from '../navbar/_logo';

export function Brand() {
    return (
        <Group gap="xs" align="center">
            <Logo />
            <div>
                <Text fw={700} size="lg" lh={1.2}>MIMIQ</Text>
                <Text size="xs" c="dimmed" lh={1}>by QPerfect</Text>
            </div>
        </Group>
    );
}
